<template>
  <section v-if="typeof(blockData)=='object' && blockData.length>0" class="section-wrapper section-11-wrapper" :style="sectionStyle">
    <!--<pre>{{ JSON.stringify(blockData[0], null, 2) }}</pre>-->
    <!--<pre>{{ JSON.stringify(componentData, null, 2) }}</pre>-->
    <div class="container section-11-container">
      <div class="row">
        <div class="col text-center">
          <a v-if="(componentData.data.dataList[0].link).length>0" class="section-11-section-title-link" :href="componentData.data.dataList[0].link" :target="componentData.data.dataList[0].target==0?'_self':'_blank'">
            <h1 class="section-wrapper-title section-11-wrapper-title section-11-section-title">{{ componentData.data.dataList[0].dataHeadLine }}</h1>
          </a>
          <h1 v-else class="section-wrapper-title section-11-wrapper-title section-11-section-title">{{ componentData.data.dataList[0].dataHeadLine }}</h1>
        </div>
      </div>
      <div class="row">
        <div
          class="col col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-12"
        >
          <div>
            <div class="section-11-post-wrapper">
              <div class="section-11-post-container">
                <div class="section-11-inner-container">
                  <div v-if="blockData[0]" :id="'section-11-' + componentData.id" class="section-11-element">
                    <!-- eslint-disable vue/no-v-for-template-key, vue/no-useless-template-attributes -->
                     <div class="row">
                        <div class="col-xl-6">
                          <div class="row">
                          <template v-for="(post, index) in blockData[0].slice(0,4)"
                          :key="index"
                          >
                            <div class="col-xl-6">
                              <div class="post-card">
                                <div
                                    class="d-flex justify-content-center align-items-center image-wrapper"
                                >
                                    <a v-if="(typeof(post.link)=='string' && (post.link).length>0)" :href="genPostLink(componentData.type, post.id)" :target="typeof(post.target)=='string' && (post.target).length>0?post.target:'_blank'">
                                        <img :src="getImages(post.content, post.images)" :alt="post.title" />
                                    </a>
                                    <img v-else :src="getImages(post.content, post.images)" :alt="post.title" />
                                </div>
                                <div class="section-11-post-title-wrapper"><a class="section-11-post-title-link" :href="genPostLink(post.type,post.id)" :title="displayEntity(post.title)">{{shorten(displayEntity(post.title), 55)}}</a></div>
                              </div>  
                            </div>
                          </template>
                          </div>
                        </div>
                        <div class="col-xl-6">
                          <div class="row">
                            <template v-for="(post, index) in blockData[0].slice(4,5)"
                            :key="index"
                            >
                              <div class="col-xl-12">
                                <div class="post-card">
                                  <div
                                      class="d-flex justify-content-center align-items-center image-wrapper"
                                  >
                                      <a v-if="(typeof(post.link)=='string' && (post.link).length>0)" :href="genPostLink(componentData.type, post.id)" :target="typeof(post.target)=='string' && (post.target).length>0?post.target:'_blank'">
                                          <img :src="getImages(post.content, post.images)" :alt="post.title" />
                                      </a>
                                      <img v-else :src="getImages(post.content, post.images)" :alt="post.title" />
                                  </div>
                                  <div class="section-11-post-title-wrapper"><a class="section-11-post-title-link" :href="genPostLink(post.type,post.id)" :title="displayEntity(post.title)">{{shorten(displayEntity(post.title), 55)}}</a></div>
                                  <div class="d-none d-lg-block section-11-post-summary-wrapper">{{shorten(displayHtmlContent(post.summary), 200)}}</div>
                                </div>  
                              </div>
                            </template>
                            </div>  
                        </div>
                      </div>
                    <!-- eslint-enable -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PublicService from "../services/public.service";
import FunctionService from "../services/function.service";

import "owl.carousel";
//import Vue from 'vue'

import jQuery from "jquery";
const $ = jQuery;
window.$ = $;

//import owlCarousel from 'owl.carousel'

export default {
  props: ["loggedIn", "componentData"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME,
      AppConst: this.$AppConst,
      posts: [],
      blockData: [],
      //blockTitle: [],
    };
  },
  created() {
    var vm = this;
    this.getBlockData(this.componentData, vm);
  },
  computed: {
    sectionStyle() {
      let newStyle = {};
      if (this.componentData.data.bgImg.length > 0) {
        newStyle.backgroundImage = "url(" + this.componentData.data.bgImg + ")";
        if (
          this.componentData.data.bgImgFixed.length > 0 &&
          this.componentData.data.bgImgFixed == 1
        ) {
          newStyle.backgroundAttachment = "fixed";
        }
      } else {
        if (this.componentData.data.bgColor.length > 0) {
          newStyle.backgroundColor = this.componentData.data.bgColor;
        }
      }
      return newStyle;
    },
  },
  components: {
    //BannerItem
  },
  mounted() {
    //this.initOwl();
  },
  methods: {
    getBlockData(cfgData, vm) {
      var resp = PublicService.getAllBlockPublicDataByType(cfgData);
      /*
      console.log("********************************************");
      console.log("resp: ");
      console.log(resp);
      console.log(typeof resp);
      */
      //if(typeof(resp) == 'object' && Object.prototype.hasOwnProperty.call(resp, "data")){
      if (typeof resp == "object") {
        var allData = [];
        resp.then(function (data) {
          //var dtCt = 0;
          data.forEach((dt) => {
            console.log(dt.data);
            allData.push(dt.data);
            //vm.blockData.push(dt.data.child);
            //vm.blockData.push(dt.data);

            if(typeof(dt.data.child)=='object'){
                vm.blockData.push(dt.data.child);
              }
              else{
                vm.blockData.push(dt.data);
              }

            //this.blockData.push(dt.data);
            /*
            console.log(cfgData.data.dataList[dtCt]);
            if(typeof(cfgData.data.dataList[dtCt])=='object' && typeof(cfgData.data.dataList[dtCt].dataHeadLine)=='string'){
                vm.blockTitle.push(
                cfgData.data.dataList[dtCt].dataHeadLine.length > 0
                    ? cfgData.data.dataList[dtCt].dataHeadLine
                    : ""
                );
            }
            dtCt++;
            */
          });
        });
        //console.log(this.blockData);
      }
      //console.log("********************************************");
    },
    removeHTML: function (data) {
      return FunctionService.removeHTML(data);
    },
    displayHtmlContent: function (data) {
      return FunctionService.displayHtmlContent(data);
    },
    getImages: function (str, imgUrl) {
      return FunctionService.getImages(str, imgUrl);
    },
    displayEntity: function (str) {
      return FunctionService.displayEntity(str);
    },
    shorten: function (str, maxLen, separator = " ") {
      return FunctionService.shorten(str, maxLen, separator);
    },
    genPostLink: function (type, id) {
      return FunctionService.genPostLink(type, id);
    },
    
  },
};

/*
export default {
  props: ["loggedIn"],
  data() {
    return {
      brand: process.env.VUE_APP_APPNAME
    };
  },
  components: {
    BannerItem
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    }
  }
};
*/
</script>

<style></style>
